<template>
  <v-row>

    <v-col cols="12" class="pr-7">
      <v-sheet width="100%" outlined>
        <v-row align="center" class="pa-2">
          
          <v-col cols="auto">
            <v-btn
              :block="$vuetify.breakpoint.xsOnly"
              color="primary"
              :to="{ name: 'newEntrepreneurshipEdition' }">
              Nuevo Emprendimiento
            </v-btn>
          </v-col>

          <v-col cols="auto">
            <v-btn
              :block="$vuetify.breakpoint.xsOnly"
              color="primary"
              @click="dialogExport = true">
              Exportar a Excel
            </v-btn>
          </v-col>

          <v-col>
            <v-tabs v-model="active_tab" class="d-flex justify-end">
              <v-tab key="0">En proceso</v-tab>
              <v-tab key="1">Pendientes</v-tab>
              <v-tab key="2">Aceptados</v-tab>
              <v-tab key="3">Rechazados</v-tab>
            </v-tabs>
          </v-col>

        </v-row>

        <v-row>
          <v-col cols="12">
            <inProgress v-if="active_tab == 0"></inProgress>
            <pending v-if="active_tab == 1"></pending>
            <accepted v-if="active_tab == 2"></accepted>
            <rejected v-if="active_tab == 3"></rejected>
          </v-col>
        </v-row>
      </v-sheet>
    </v-col>

    <v-dialog
      v-model="dialogExport"
      max-width="500"
    >
      <v-card>
        <v-card-title>
          Exportar formularios
        </v-card-title>

        <v-card-text>

          <p class="mb-4">
            Seleccione los estados que desea incluir en el archivo Excel.
          </p>

          <v-checkbox
            v-model="exportOptions.inProgress"
            label="En proceso"
            hide-details
          />

          <v-checkbox
            v-model="exportOptions.pending"
            label="Pendientes"
            hide-details
          />

          <v-checkbox
            v-model="exportOptions.accepted"
            label="Aceptados"
            hide-details
          />

          <v-checkbox
            v-model="exportOptions.rejected"
            label="Rechazados"
            hide-details
          />

        </v-card-text>

        <v-card-actions>
          <v-spacer />

          <v-btn
            text
            @click="dialogExport = false"
          >
            Cancelar
          </v-btn>

          <v-btn
            color="primary"
            :loading="loadingExcel"
            :disabled="!hasAnySelected"
            @click="exportToExcel"
          >
            Exportar
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    
  </v-row>
</template>

<script>
  import axios from 'axios'
  import inProgress from '@/components/admin/editions/entrepreneurships/inProgress.vue'
  import pending from '@/components/admin/editions/entrepreneurships/pending.vue'
  import accepted from '@/components/admin/editions/entrepreneurships/accepted.vue'
  import rejected from '@/components/admin/editions/entrepreneurships/rejected.vue'

  export default {
    name: 'entrepreneurshipsEdition',
    components: {
      inProgress,
      pending,
      accepted,
      rejected
    },
    data: () => ({
      edition_id:null,
      loading:false,
      loadingExcel: false,
      dialogExport: false,
      exportOptions: {
        inProgress: true,
        pending: true,
        accepted: true,
        rejected: true
      }
    }),
    computed: {
      hasAnySelected() {
        return Object.values(this.exportOptions).some(value => value)
      },
      active_tab: {
        get() {
          return this.$store.state.entrepreneurships_edition_tab
        },
        set(value) {
          this.$store.commit('setEntrepreneurshipsEditionTab', value)
        }
      }
    },
    methods:{
      async exportToExcel() {
        this.loadingExcel = true
        try {
          const response = await axios.get(
            'admin/edition/' + this.edition_id + '/convocation-form/export-excel',
            {
              responseType: 'blob',
              params: {
                in_progress: this.exportOptions.inProgress,
                pending: this.exportOptions.pending,
                accepted: this.exportOptions.accepted,
                rejected: this.exportOptions.rejected
              }
            }
          )


          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'Formularios Convocatoria.xlsx')
          document.body.appendChild(link)
          link.click()
          link.remove()
          window.URL.revokeObjectURL(url)
        } catch (error) {
          console.error('Error al exportar:', error)
        } finally {
          this.loadingExcel = false
        }
      }
    },
    created(){
      this.edition_id = this.$route.params.edition_id;
    }
  }
</script>